import {
  recognitionDefaultValuesService,
  CreateRecognitionDefaultValueRequest,
  RecognitionDefaultValue,
  UpdateRecognitionDefaultValueRequest,
} from '@aslanpay/portal-common-lib';
import { useMutation } from '@tanstack/react-query';

interface UpdateDefaultValueVariables {
  defaultValueId: string;
  body: UpdateRecognitionDefaultValueRequest;
}

const useRecognitionDefaultValueMutations = () => {
  const createDefaultValue = useMutation<
    RecognitionDefaultValue,
    Error,
    CreateRecognitionDefaultValueRequest
  >((body) => recognitionDefaultValuesService.createRecognitionDefaultValue(body));

  const updateDefaultValue = useMutation<
    RecognitionDefaultValue,
    Error,
    UpdateDefaultValueVariables
  >(({ defaultValueId, body }) =>
    recognitionDefaultValuesService.updateRecognitionDefaultValue(defaultValueId, body)
  );

  const deleteDefaultValue = useMutation<unknown, Error, string>((defaultValueId) =>
    recognitionDefaultValuesService.deleteRecognitionDefaultValue(defaultValueId)
  );

  return { createDefaultValue, updateDefaultValue, deleteDefaultValue };
};

export default useRecognitionDefaultValueMutations;
